export const HOME = "/";
export const NEW_CHART = "/new";
export const CHART_PREFIX = "/chart/";
export const CHART = `${CHART_PREFIX}:chartId`;
export const PROFILE = "/profile";
export const SUBSCRIPTION = "/subscription";
export const BRANDING = "/branding";
export const CONTACT = "/contact";
